import { Toast } from "primereact/toast";
import { useEffect, useRef, useState } from "react";
import "slick-carousel/slick/slick-theme.css";
import "slick-carousel/slick/slick.css";
import { HOME_PAGE, HOME_PAGE_CONSTANTS } from "../constants/app-constants";
import { getCurrentUserFromLocalStorage, getI18nLanguageFromLocalStorage } from "../helpers/localStorageHelper";
import { useScrollRestore } from '../hook/useScrollRestore';
import useCurrency from "../hook/useCurrency";
import { i18n, initializeI18n } from "../localization/i18n";
import { postCourseItemAddToCartData } from "../services/courseService";
import { getVodPackagesData } from "../services/homePageService";
import { ErrorTemplate, SuccessTemplate } from "./common/ToastMessage/Template";
import VODItem from "./vod/VodItem";
import { Carousel } from "primereact/carousel";
import { translate } from "../localization/translateService";
import "/node_modules/flag-icons/css/flag-icons.min.css";

export default function VodPackageSection({ props }) {
  const { className = "", quantity = 0 } = props;
  const [vodPackageList, setVodPackageList] = useState([]);
  const [currentLanguage, setCurrentLanguage] = useState(null);
  const currentUser = getCurrentUserFromLocalStorage();
  const language = getI18nLanguageFromLocalStorage();

  const { saveScrollPosition } = useScrollRestore(HOME_PAGE.VOD_SECTION_SCROLL_POSITION);

  const [translations, setTranslations] = useState({
    headerTitle: "",
    headerSubtitle: "",
    noSuggestedVOD: "",
    noMatchVOD: "",
    ADD_SUCCESS: "",
    ADD_FAIL: "",
    PDF_AVAILABLE: "",
    freeLabel: "",
  });
  const [translationLoaded, setTranslationLoaded] = useState(false);

  const sliderRef = useRef(null);
  const toast = useRef(null);

  const { display } = useCurrency();

  const showErrorToast = (message) => {
    toast.current.show({
      severity: "error",
      detail: message,
      life: 3000,
      content: (props) => ErrorTemplate(props),
    });
  };

  const showSuccessToast = (message) => {
    toast.current.show({
      severity: "success",
      detail: message,
      life: 3000,
      content: (props) => SuccessTemplate(props),
    });
  };

  const handleAddToCart = (event, productPublicId) => {
    event.stopPropagation();
    event.preventDefault();
    if (currentUser) {
      postCourseItemAddToCartData(productPublicId)
        .then(() => {
          showSuccessToast(props.addVODToShoppingCartSuccessMessage);
        })
        .catch(() => {
          showErrorToast(props.addVODToShoppingCartFailMessage);
        });
    } else {
      window.location.href = `/auth/login?lang=${language}&returnUrl=${window.location.pathname}`;
    }
  };

  useEffect(() => {
    setTimeout(() => {
      if (sliderRef?.current) {
        if (sliderRef.current.state.breakpoint) {
          sliderRef.current.slickGoTo(0);
        }
      }
    }, 100);
  }, [sliderRef.current]);

  useEffect(() => {
    if (!i18n.isInitialized) {
      initializeI18n().then(() => {
        setCurrentLanguage(i18n.language);
      });
    } else {
      setCurrentLanguage(i18n.language);
    }
  }, []);

  function SampleNextArrow(props) {
    const { className, onClick } = props;
    return (
      <div className={className} onClick={onClick}>
        <i className="pi pi-angle-right"></i>
      </div>
    );
  }

  function SamplePrevArrow(props) {
    const { className, onClick } = props;
    return (
      <div className={className} onClick={onClick}>
        <i className="pi pi-angle-left"></i>
      </div>
    );
  }

  const sliderSettings = {
    dots: false,
    infinite: false,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    initialSlide: 0,
    nextArrow: <SampleNextArrow />,
    prevArrow: <SamplePrevArrow />,
    responsive: [
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
        },
      },
      {
        breakpoint: 1150,
        settings: {
          slidesToShow: 2,
        },
      },
    ],
  };

  useEffect(() => {
    const fetchVodPackagesData = async () => {
      const data = await getVodPackagesData({
        quantity: HOME_PAGE_CONSTANTS.GET_VOD_PACKAGE_QUANTITY,
      });
      if (quantity) {
        setVodPackageList(data?.slice(0, quantity));
      } else {
        setVodPackageList(data);
      }
    };
    fetchVodPackagesData();

    const loadTranslations = async () => {
      try {
        const headerTitle = await translate("UMBRACO_LANDING.VOD.HEADER_TITLE");
        const headerSubtitle = await translate(
          "UMBRACO_LANDING.VOD.HEADER_SUBTITLE"
        );

        const noSuggestedVOD = await translate(
          "UMBRACO_LANDING.VOD.NO_SUGGESTED_VOD"
        );
        const noMatchVOD = await translate("UMBRACO_LANDING.VOD.NO_MATCH_VOD");
        const addSuccess = await translate("UMBRACO_LANDING.VOD.ADD_TO_CART_SUCCESS");
        const addFail = await translate("UMBRACO_LANDING.VOD.ADD_TO_CART_FAIL");
        const pdfAvailable = await translate("UMBRACO_LANDING.VOD.PDF_AVAILABLE");
        const freeLabel = await translate("COURSES.LABELS.FREE");
        setTranslations({
          headerTitle,
          headerSubtitle,
          noSuggestedVOD,
          noMatchVOD,
          ADD_SUCCESS: addSuccess,
          ADD_FAIL: addFail,
          PDF_AVAILABLE: pdfAvailable,
          freeLabel,
        });
      } catch (error) {
      } finally {
        setTranslationLoaded(true);
      }
    };
    // selectedCategory(COURSE_CATEGORIES.ALL.code)
    loadTranslations();
  }, []);

  const carouselItemTemplate = (course) => {
    return (
      <div className="p-3 h-full">
        <VODItem
          course={course}
          onClick={() => {
            saveScrollPosition();
            const language = getI18nLanguageFromLocalStorage();
            window.open(`/${language}/vod/${course.publicId}`, "_self");
          }}
          translations={translations}
          // handleAddToShoppingCart={handleAddToShoppingCart}
          toast={toast}
        />
      </div>
    );
  };

  return (
    <div className={`vod-package-section ${className}`}>
      <Toast ref={toast} position="bottom-right" className="keduall-toast" />
      <div className="vod-package-title text-center mx-2">
        <h1 className="text-primary-txt-color line-height-57 text-6xl font-semibold margin-bottom-12 mt-0 animate-on-scroll">{props?.vodPackageSectionTitle1}</h1>
        <h4 className="text-2xl font-normal line-height-32 my-0 animate-on-scroll">{props?.vodPackageSectionTitle2}</h4>
      </div>
      <div className="keduall-carousel-container width-limited" style={{ width: "85%" }}>
        <Carousel
          value={vodPackageList}
          itemTemplate={carouselItemTemplate}
          numVisible={3}
          numScroll={3}
          className="keduall-carousel"
          responsiveOptions={[
            { breakpoint: "1024px", numVisible: 3, numScroll: 3 },
            { breakpoint: "768px", numVisible: 2, numScroll: 2 },
            { breakpoint: "560px", numVisible: 1, numScroll: 1 },
          ]}
          showIndicators={vodPackageList.length > 3}
          showNavigators={vodPackageList.length > 3}
        />

        {/* <Slider ref={sliderRef} {...sliderSettings}>
          {vodPackageList.map((item, index) => (
            <div key={index}>
              <div className="m-3 h-full">
                <VODItem
                  course={item}
                  disabledAddToCart={true}
                  onClick={() => {
                    const language = getI18nLanguageFromLocalStorage();
                    return window.location.href = `/${language}/vod/${item.publicId}`;
                  }}
                  translations={translations}
                  // handleAddToShoppingCart={handleAddToShoppingCart}
                  toast={toast}
                />
              </div>
            </div>
          ))}
        </Slider> */}
      </div>
    </div>
  );
}
